export const jsonKeyColor = ' style="color: #ec2b86ff" ';
export const jsonValueColor = ' style="color: #00aae2ff" ';

function indent(level: number): string {
  return '&nbsp;'.repeat(level * 4);
}

function renderPrimitive(value: unknown): string {
  if (typeof value === 'number' || typeof value === 'boolean') {
    return `<span ${jsonValueColor}>${String(value)}</span>`;
  }
  return `<span ${jsonValueColor}>"${String(value)}"</span>`;
}

export function renderJsonHtml(obj: any, level: number = 0): string {
  let parsedObj = obj;
  if (typeof obj === 'string') {
    try {
      parsedObj = JSON.parse(obj);
    } catch { /* */ }
  }

  if (typeof parsedObj !== 'object' || parsedObj === null) {
    return renderPrimitive(parsedObj);
  }

  if (Array.isArray(parsedObj)) {
    const spaced = indent(level + 1);
    const items = parsedObj.map((item, i) => {
      const rendered = renderJsonHtml(item, level + 1);
      const comma = i < parsedObj.length - 1 ? ',' : '';
      return `${spaced}${rendered}${comma}<br>`;
    }).join('');
    return `[<br>${items}${indent(level)}]`;
  }

  const keys = Object.keys(parsedObj);
  const spaced = indent(level + 1);
  const entries = keys.map((key, i) => {
    const comma = i < keys.length - 1 ? ',' : '';
    const rendered = renderJsonHtml((parsedObj as Record<string, unknown>)[key], level + 1);
    return `${spaced}<span ${jsonKeyColor}>"${key}"</span>: ${rendered}${comma}<br>`
  }).join('');
  return `{<br>${entries}${indent(level)}}`;
}
